<div class="callModal" role="dialog">
  <div class="modal-body">
    <p class="incoming-call">{{messageText | translate}}</p>
    <img class="call_image call_image-back" src="/assets/images/call/remoteCallBack.svg">
    <div class="call_image-box call_image">
      <img id="call_modal_image" class="call_image call_avatar" src="/assets/images/call/nophoto-contact.svg">
    </div>
    <p class="incoming-call" id="timerElement"></p>
  </div>

  <div class="modal-footer">
    <div class="dismiss-call">
      <div class="button only-decline" data-dismiss="modal" (click)="endDialog(false)"> <i class="fa fa-phone"></i> </div>
    </div>
  </div>
</div>

